import React, { useEffect, useState } from 'react';
import Modal from 'common/components/modules/modal';
import Button from 'common/components/elements/buttons/primary';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons';
import GenerateColor from 'common/utils/generateTextColor.js'
// import Input from 'common/components/elements/inputs/inputs';
import NumberFormatter from 'common/utils/NumberFormatter';
import DateFormatter from 'common/utils/DateFormatter';
import ChoosePaymentType from './choose-payment-type';
import Router from 'sites/routes/router';
import { WarningOfScoreContent } from './warning-of-score';
import Waveform from 'common/components/modules/audio-player';
import StoreImgCard from 'sites/views/store/store-image-card';

import './style.scss';
import TruncateText from 'common/components/elements/truncate-text';
import IconLabel from 'common/components/elements/icon-label';
import CircleLoader from 'common/components/elements/loader/circle';
import { upperCaseFirstLetter } from 'common/utils/utils'
import cx from 'classnames'

const UNLOCK_CONTENT = ['photo_unlock', 'video_unlock', 'voice_unlock'];
const numberFormatter = new NumberFormatter();

const PurchaseMethodModal = ({
   onModalClose,
   selectedAmount,
   isMobile,
   balance,
   ownerAvatar,
   ownername,
   onSend,
   isSend,
   isDisabled,
   isNotEnoughtBalance,
   goToWalletTopUp,
   isGoBack,
   goBack,
   type,
   onDownload,
   isOpenChoosePaymentModal,
   onContinue,
   savedPaymentMethod,
   animate,
   height,
   isFetchingBalance,
   mediaName,
   isCheckLimitFetching,
   mediaData,
   goToMedia,
   locationPath,
   methods,
   oneClickInfo,
   paymentError,
   clearErrorState,
   onlyWalletPay,
   paymentSend,
   contentData,
   chatPanel,
   videoType,
   extraInfo,
   purchaseData,
   onCloseSuccessModal,
   isFetchingModal,
   siteInfo,
   onShare,
   pageType,
   onChangeFavoriteItem,
   isChat,
   isDownloadPurchase,
}) => {
   const modalHeight = isMobile ? 'calc(100% - 61px)' : height > 750 ? '610px' : height - 100 + 'px';
   const isDeclined = oneClickInfo?.isDeclined;
   const reason = oneClickInfo?.reason;
   const oneClickType = oneClickInfo?.type;
   const isOrderRequestWithWallet = !oneClickType && !isSend && purchaseData?.is_order_request && !['order-details', 'all'].includes(pageType) && !isNotEnoughtBalance

   const getPurchaseText = (type) => {
      let text = type;
      switch (type) {
         case 'chat_text_message':
            text = 'chat text message'
            break;
         case 'chat_voice_message':
            text = 'Chat voice message'
            break;
         case 'chat_photo_message':
            text = 'Chat image message'
            break;
         case 'multiple_attachment':
            text = 'Purchase multiple attachments message of'
            break;

         default:
            break;
      }
      return upperCaseFirstLetter(text);
   }

   return (
      <Modal
         contentPosition={ !isMobile ? 'center' : 'bottom' }
         onClose={ (e) => onModalClose(e, type === 'tip' && isSend) }
         contentWidth={ isMobile ? '100%' : '375px'  }
         otherClassName={
            `${ isMobile ?  '' :
               type === 'store' &&
               `${ !!methods.one_click ? isSend || !isOpenChoosePaymentModal ? '!w-[375px]' : !methods?.wallet && !methods.one_click ? '!w-[375px]' : '!w-[742px]' : !methods?.wallet ? '!w-[375px]' : isSend || !isOpenChoosePaymentModal ? '!w-[375px]' : '!w-[742px]' }` }` }
         animate={ isMobile ? animate : null }
         isCloseAction={ false }
      >
         {
            paymentError && paymentError.error_type ? (
               <>
                  <WarningOfScoreContent
                     onModalClose={ clearErrorState }
                     item={
                        {
                           name: mediaName,
                           price: selectedAmount,
                           type: paymentError.payment_type,
                        }
                     }
                     walletBalance={ paymentError.wallet_balance }
                     message={ paymentError }
                     purchaseUsingWallet={ () => onSend('wallet') }
                     fetchPaymentUsingWallet={ isDisabled }
                  />
               </>
            ) : (
               <>
                  {
                     isOpenChoosePaymentModal ? (
                        <>
                           {
                              isFetchingModal && (
                                 <div
                                    style={ {
                                       height: '418px',
                                    } }
                                    className='w-full flex flex-col pb-5'>
                                    <div className='header-shadow px-4 py-3 flex items-center'>
                                       <div className='w-6 h-6'>
                                          <Button
                                             iconName='close'
                                             fontIconColor='major'
                                             darkIconcolor='major-dark'
                                             classNames='h-full w-full'
                                             backgroundColor='transparent'
                                             waveColor='rgba(33, 33, 33, 0.8)'
                                             padding='none'
                                             onClick={ onModalClose }
                                          />
                                       </div>
                                       <span className='leading-tight text-major dark:text-major-dark'> Payment method </span>
                                    </div>
                                    <div
                                       className='w-full flex flex-1 items-center justify-center'
                                    >
                                       <CircleLoader />
                                    </div>
                                    <div className='h-12 mt-5 w-full px-5'>
                                       <Button
                                          text='Buy now'
                                          textSize='base'
                                          iconPosition='left'
                                          fontIconSize='base'
                                          primaryColor
                                          borderRadius='large'
                                          classNames='h-full py-2'
                                          padding='none'
                                          disabled={ true }
                                          onClick={ _ => {} }
                                       />
                                    </div>
                                 </div>
                              )
                           }
                           {
                              !isFetchingModal && (
                                 <ChoosePaymentType
                                    onModalClose={ onModalClose }
                                    balance={ balance }
                                    type={ type }
                                    onContinue={ onContinue }
                                    savedPaymentMethod={ savedPaymentMethod }
                                    isDisabled={ isDisabled || isFetchingBalance || isCheckLimitFetching }
                                    methods={ methods }
                                    onOneClickPay={ () => onSend('one_click')  }
                                    showNewStyles={ type === 'store' }
                                    purchaseData={ purchaseData }
                                    isMobile={ isMobile }
                                 />

                              )
                           }
                        </>
                     ) : (
                        <div
                           style={ { maxHeight: modalHeight } }
                           className='w-full'
                        >
                           <div className={ `h-auto flex flex-col w-full p-6` }>
                              <div className={
                                 cx({
                                    [`flex ${ oneClickType ? type !== 'store' && 'items-center pb-3' : '' }`]: true,
                                    [`flex-col items-end`]: isOrderRequestWithWallet,
                                 })
                              }>
                                 {
                                    isDeclined ?
                                       <div className='flex flex-col gap-4 items-center w-full'>
                                          <IconLabel
                                             name='payment-card'
                                             className='w-10 h-10'
                                             color='error'
                                             darkIconColor='error-dark'
                                             size={ `2xl` }
                                          />
                                          <p className='font-semibold text-xl text-major dark:text-major-dark'>Your payment was declined</p>
                                       </div>
                                       :
                                       (!isSend || type !== 'store') &&
                                       <div className={ cx({
                                          'w-6 h-6 mr-4': true,
                                          [`!m-0`]: isOrderRequestWithWallet,
                                          'hidden': isDownloadPurchase && 'video' === (oneClickInfo.type || type),
                                       }) }>
                                          <Button
                                             iconName={ isGoBack ? 'arrow-left' : 'close' }
                                             fontIconColor='major'
                                             darkIconcolor='major-dark'
                                             classNames='h-full w-full'
                                             backgroundColor='transparent'
                                             padding='none'
                                             onClick={ (e) => { isGoBack ? goBack() : onModalClose(e, type === 'tip' && isSend) } }
                                          />
                                       </div>
                                 }
                                 {
                                    !oneClickType && !isSend && (
                                       <div className={ cx({
                                          'w-full flex items-center flex-col pr-10 pt-1 pb-5': true,
                                          [`!p-0 !pt-[18px]`]: isOrderRequestWithWallet,
                                       }) }>
                                          <div
                                             style={ {
                                                background: GenerateColor.generateRGBColor(window.skinPrimaryColor, 0.08),
                                             } }
                                             className='w-10 h-10 mb-3 rounded-full flex items-center justify-center'>
                                             <Icon name='wallet' primaryColor={ window.skinPrimaryColor } size='2xl' />
                                          </div>
                                          {
                                             isOrderRequestWithWallet ?
                                                <span className='font-semibold text-xl text-major dark:text-major-dark leading-5 text-center'>Order payment confirmation</span>
                                                :
                                                <span
                                                   className='text-sm text-secondary dark:text-secondary-dark'
                                                   style={ { lineHeight: '16px' } }
                                                >
                                                   YOU HAVE { numberFormatter.withDots(balance) } USD
                                                </span>
                                          }
                                       </div>

                                    )
                                 }
                                 {/* {
                                    !!oneClickType && (
                                       <span
                                          className='text-sm text-secondary dark:text-secondary-dark'
                                          style={ { lineHeight: '16px' } }
                                       >
                                          {
                                             !isDisabled && !isDeclined && type !== 'store' && 'Success'
                                          }
                                       </span>
                                    )
                                 } */}

                              </div>
                              {
                                 isDeclined && (
                                    <div className=' flex flex-col justify-center items-center **mt-4 **gap-8'>
                                       <div>
                                          {
                                             reason && (
                                                <div className='flex flex-col items-center justify-center px-5 mt-4'>
                                                   {/* <span
                                                      className='text-base text-major dark:text-major-dark text-center leading-tight'
                                                   >
                                                      {reason.header}
                                                   </span> */}
                                                   <span
                                                      className='text-base text-secondary dark:text-secondary-dark text-center leading-tight'
                                                   >
                                                      Reason: {reason.body}
                                                   </span>
                                                </div>
                                             )
                                          }
                                          {/* {
                                             !reason && (
                                                <div className={ `flex flex-col items-center justify-center px-5 ${ type === 'store' && isMobile && '!w-[375px]' }` }>
                                                   <span
                                                      className='text-base text-secondary dark:text-secondary-dark text-center leading-tight'
                                                   >
                                                      Your payment was declined
                                                   </span>

                                                </div>
                                             )

                                          } */}
                                       </div>
                                       <Button
                                          text='Contact support'
                                          textSize='small'
                                          // iconName='help-outline'
                                          textColor='secondary'
                                          darkIconcolor='secondary-dark'
                                          iconPosition='left'
                                          classNames='px-[14px] !w-fit h-9 mt-8'
                                          padding='none'
                                          backgroundColor='transparent'
                                          textMarginX='0 ml-2'
                                          onClick={ () => {
                                             if(window.Intercom) {
                                                window.Intercom('show');
                                             }
                                          } }
                                       />
                                       <Button
                                          text='Ok'
                                          primaryColor
                                          textColor='secondary'
                                          darkIconcolor='secondary-dark'
                                          classNames=' !w-fit h-9 mt-3'
                                          backgroundColor='transparent'
                                          padding='none'
                                          textClassName='text-sm dark:text-secondary-dark'
                                          onClick={ (e) => { isGoBack ? goBack() : onModalClose(e, type === 'tip' && isSend) } }
                                       />
                                    </div>
                                 )
                              }

                              {
                                 !isDeclined && (
                                    <>
                                       {
                                          isNotEnoughtBalance ? (
                                             <div className='mx-1 pb-1'>
                                                <div className='flex flex-col justify-center items-center cursor-pointer mt-4'>
                                                   <div className='flex flex-col items-center justify-center px-5'>
                                                      <p
                                                         className='text-base text-secondary dark:text-secondary-dark text-center'
                                                         style={ { lineHeight: '20px' } }
                                                      >
                                                         Your wallet balance is insufficent to make this purchase. Please top up your wallet to continue.
                                                      </p>
                                                   </div>
                                                   <div className='mt-8 mb-1'>
                                                      <Button
                                                         text='Go to wallet top up'
                                                         textSize='base'
                                                         primaryColor
                                                         padding='none'
                                                         classNames='h-full w-full px-3'
                                                         onClick={ goToWalletTopUp }
                                                         backgroundColor='transparent'
                                                      />
                                                   </div>
                                                </div>
                                             </div>
                                          ) : (
                                             <div className={ cx({
                                                'mx-1 pb-1': type !== 'store',
                                                '!mx-0 !pb-0': isDownloadPurchase && 'video' === (oneClickInfo.type || type),
                                             }) }>
                                                {
                                                   isSend ? (
                                                      <SendContent
                                                         ownername={ ownername }
                                                         onModalClose={ onModalClose }
                                                         contentType={ oneClickInfo.type || type }
                                                         onDownload={ onDownload }
                                                         mediaData={ oneClickInfo.data || mediaData }
                                                         goToMedia={ goToMedia }
                                                         locationPath={ locationPath }
                                                         videoType={ videoType }
                                                         clearErrorState={ clearErrorState }
                                                         extraInfo={ extraInfo }
                                                         purchaseData={ purchaseData }
                                                         onCloseSuccessModal={ onCloseSuccessModal }
                                                         siteInfo={ siteInfo }
                                                         onShare={ onShare }
                                                         onChangeFavoriteItem={ onChangeFavoriteItem }
                                                         isChat={ isChat }
                                                         isDownloadPurchase={ isDownloadPurchase }
                                                         onClickButton={ (action, e) => {
                                                            if('close' === action){
                                                               onModalClose(e, type === 'tip' && isSend)
                                                            } else if('download' === action){
                                                               onDownload()
                                                            }
                                                         } }
                                                      />
                                                   ) : (
                                                      <>
                                                         {
                                                            !!onlyWalletPay && (

                                                               <span
                                                                  className='text-base text-secondary dark:text-secondary-dark leading-tight mt-4 block mb-4'>
                                                                  Items that cost less than 4.00 USD can be purchased only using the <span className='font-medium'>Wallet</span>
                                                                  {/* <span
                                                                     className='cursor-pointer ml-px inline-flex items-center justify-center w-5 h-5 more-info-on-wallet' >
                                                                     <Icon name='help-outline' color='secondary' darkColor='secondary-dark'
                                                                        style={ {
                                                                           height: '16.67px',
                                                                        } }
                                                                     />
                                                                  </span> */}
                                                               </span>
                                                            )
                                                         }

                                                         <div className={ cx({
                                                            'flex flex-col items-center justify-center pt-7': true,
                                                            '!pt-4': isOrderRequestWithWallet,
                                                         }) }>
                                                            {
                                                               !UNLOCK_CONTENT.includes(type) && (
                                                                  isOrderRequestWithWallet ?
                                                                     <div className='test-base leading-5 text-secondary dark:text-secondary-dark text-center'>
                                                                        You will be charged <span className='font-bold'>{purchaseData?.total} USD</span>. {ownername} can accept or decline this order. If declined, you'll receive a full refund.
                                                                     </div>
                                                                     :
                                                                     <div
                                                                        className='modal-avatar overflow-hidden rounded-full mb-4 cursor-pointer'
                                                                     >
                                                                        <img src={ ownerAvatar } alt='avatar' className='w-full h-full object-cover' />
                                                                     </div>
                                                               )
                                                            }
                                                            {
                                                               !isOrderRequestWithWallet &&
                                                               <>
                                                                  <p
                                                                     className='text-center text-2xl mb-2 text-major dark:text-major-dark'
                                                                     style={ { lineHeight: '28px', maxWidth: '255px' } }
                                                                  >
                                                                     { selectedAmount } USD
                                                                  </p>
                                                                  <p
                                                                     className='text-sm text-secondary text-center dark:text-secondary-dark '
                                                                     style={ { lineHeight: '20px' } }
                                                                  >
                                                                     {
                                                                        UNLOCK_CONTENT.includes(type) ? (
                                                                           `Pay ${ selectedAmount } USD from your wallet and unlock the ${ type.replace('_unlock', '') }.`
                                                                        ) : (
                                                                           <>
                                                                              <span className=''>{ (type === 'video' || type === 'photoset') ? 'Purchase' : getPurchaseText(type) }</span>
                                                                              { type === 'video' || type === 'photoset' ? ' ' + mediaName :  ' ' + ownername } from your wallet
                                                                           </>
                                                                        )
                                                                     }
                                                                     {/* <span className='capitalize'>{ (type === 'video' || type === 'photoset' || type === 'media_unlock') ? 'Purchase' : type }</span> { (type === 'video' || type === 'photoset') ? mediaName : ownername } from your wallet */}
                                                                  </p>
                                                               </>
                                                            }
                                                         </div>
                                                         {
                                                            !isOrderRequestWithWallet &&
                                                            <div className={ `flex items-center justify-center ${ isDisabled ? 'mt-5' : 'mt-12' }` }>
                                                               {
                                                                  isDisabled && (
                                                                     <p className='mb-3 text-sm text-secondary dark:text-secondary-dark leading-tight'>PROCESSING PAYMENT...</p>
                                                                  )
                                                               }
                                                            </div>
                                                         }
                                                         <div className={ cx({
                                                            'w-full': true,
                                                            'flex flex-col gap-3 mt-8': isOrderRequestWithWallet,
                                                         }) }>
                                                            <div className='h-9 w-full'>
                                                               <Button
                                                                  text={ isOrderRequestWithWallet ? 'Confirm' : type === 'tip' ? 'Send tip' : 'Pay from my wallet' }
                                                                  textSize='small'
                                                                  iconPosition='left'
                                                                  fontIconSize='base'
                                                                  primaryColor
                                                                  borderRadius='large'
                                                                  classNames='h-full'
                                                                  padding='none'
                                                                  disabled={ isDisabled }
                                                                  isLoading={ isDisabled || isFetchingBalance }
                                                                  onClick={ () => onSend('wallet')  }
                                                               />
                                                            </div>
                                                            {
                                                               isOrderRequestWithWallet &&
                                                                  <Button
                                                                     text='Cancel'
                                                                     textSize='small'
                                                                     iconPosition='left'
                                                                     fontIconSize='base'
                                                                     borderRadius='large'
                                                                     classNames='h-9 !w-fit mx-auto'
                                                                     padding='none'
                                                                     backgroundColor='transparent'
                                                                     textClassName='text-secondary dark:text-secondary-dark'
                                                                     onClick={ (e) => { isGoBack ? goBack() : onModalClose(e, type === 'tip' && isSend) } }
                                                                  />
                                                            }
                                                         </div>
                                                      </>
                                                   )
                                                }
                                             </div>
                                          )
                                       }
                                    </>

                                 )
                              }
                           </div>
                        </div>
                     )
                  }
               </>
            )
         }
      </Modal>

   );
};

const SendContent = ({
   contentType,
   ownername,
   onModalClose,
   mediaData,
   goToMedia,
   locationPath,
   clearErrorState,
   videoType,
   extraInfo,
   purchaseData,
   onCloseSuccessModal,
   siteInfo,
   onShare,
   onChangeFavoriteItem,
   isChat,
   isDownloadPurchase,
   onClickButton = () => {},
}) => {
   let time = '';
   let src = '';
   let icon = '';
   let buttonText = '';
   let mediaUrl = '/';
   let transacationId = null;
   let type = contentType;
   const [isFavoriteItem, setIsFavourieItem] = useState(false)
   const isVideoDownoadPurchase = isDownloadPurchase && 'video' === type

   useEffect(() => {
      setIsFavourieItem(mediaData?.is_favorite)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   if(mediaData && 'voice_unlock' !== type) {
      buttonText = 'Go to video';
      transacationId = mediaData.transacationId;
      time = DateFormatter.getSecondsConversion(mediaData.duration);
      src = mediaData.poster_src;
      icon = 'play-default';
      if(type === 'mass_message') type = mediaData.type;
      if('photoset' === type || 'photo_unlock' === type){
         buttonText = 'Go to photoset';
         time = `${ mediaData.photos_count } photo${ mediaData.photos_count > 1 ? 's' : '' }`;
         src = mediaData.photos ? mediaData.photos[0] : '';
         icon = 'several-images'
         if('photo_unlock' === type){
            buttonText = 'Go to photo';
            time = '';
         }
      }
      if('livestream' === type){
         buttonText = 'Go to livestream';
         // src = mediaData.photos ? mediaData.photos[0] : '';
      }
      if('store' === type) {
         time = null;
         buttonText = 'Go to store';
      }
      if('video' === type && 'livestream' === videoType){
         type = 'record';
         buttonText = 'Go to recorded stream'
      }
      const appRouts = {
         'video': 'VIDEOS_INDIVIDUAL',
         'record': 'LIVE_STREAM_RECORD',
         'photoset': 'PHOTOSETS_INDIVIDUAL',
         'photo_unlock': 'CHAT_UNLCOKED_CONTENT',
         'video_unlock': 'CHAT_UNLCOKED_CONTENT',
         'store': 'STORE_DETAILS',
         'wallet': 'WALLET',
         'livestream': 'LIVE_STREAM_STUDIO',
      }
      let url = appRouts[type] || 'HOMEPAGE'
      mediaUrl = Router.route(url).getCompiledPath({ id: mediaData.id })
   }

   let isShowButton = false;
   if(['chat_text_message', 'chat_voice_message', 'chat_photo_message', 'tip', 'voice_unlock'].includes.type) {
      isShowButton = true;
      if('video' === type && Router.route('VIDEOS_INDIVIDUAL').match(locationPath)){
         isShowButton = false;
      }
      if('photoset' === type && Router.route('PHOTOSETS_INDIVIDUAL').match(locationPath)) {
         isShowButton = false;
      }
   }
   if(type === 'wallet') {
      buttonText = 'Go to wallet';
   }

   return (
      <div className={ cx({
         [`flex flex-col items-center justify-center ${ type !== 'store' ? 'mt-9' : '' }`]: true,
         '!mt-0': isVideoDownoadPurchase,
      }) }>
         <div className='flex flex-col items-center justify-center'>
            {
               type !== 'store' &&
               <IconLabel
                  name='done'
                  color='success'
                  className='h-10 w-10 mb-5'
               />
            }
            <div>
               {
                  type !== 'tip' ? (
                     type === 'store' && !!purchaseData ?
                        <div className=' bg-panel dark:bg-panel-dark flex flex-col items-center'>
                           <div className='w-10 h-10 flex items-center justify-center rounded-full bg-success-12 mb-3'>
                              <Icon
                                 name='done'
                                 color='success'
                                 size='[18px]'
                              />
                           </div>
                           <span className='text-xl font-semibold mb-4 dark:text-major-dark text-major'>Thanks for your purchase!</span>
                           <span className='text-secondary mb-6 dark:text-secondary-dark'>Your payment was successful</span>
                           <div
                              className='w-full mb-8'
                           >
                              <div className='flex flex-col justify-end store-card select-none'>
                                 <TruncateText
                                    // notranslate-content-title
                                    className='text-xl font-medium store-name dark:text-major-dark text-major select-text mb-2 notranslate'
                                    text={ purchaseData?.storeData?.name }
                                    textSize='20px'
                                    fontWeight='500'
                                 />
                                 <StoreImgCard
                                    src={ purchaseData?.storeData?.src }
                                    price={ `${ purchaseData?.storeData?.price }` }
                                    isShowPrice={ false }
                                    isCustomImg={ false }
                                    className='store-img  rounded-lg'
                                    data={ {
                                       ...purchaseData?.storeData,
                                       is_favorite: isFavoriteItem,
                                    } }
                                    siteInfo={ siteInfo }
                                    onShare={ onShare }
                                    id={ purchaseData?.id }
                                    onChangeFavoriteItem={ (id, type) => onChangeFavoriteItem(id, type, () => setIsFavourieItem(!isFavoriteItem)) }
                                 />
                              </div>
                           </div>
                           {
                              ['content_bundle_item', 'attachment_item']?.includes(purchaseData?.storeData?.product_type) &&
                              <Button
                                 text='Go to My unlocks'
                                 iconName='go-to'
                                 backgroundColor='transparent'
                                 primaryColor
                                 classNames='mx-auto !py-2 w-[47px] h-9 flex gap-2 mb-3'
                                 textSize='small'
                                 textMarginX='0'
                                 onClick={ () => {
                                    window.open(Router.route('MY_MEDIA').getCompiledPath())
                                    onCloseSuccessModal()
                                 } }
                              />
                           }
                           <Button
                              text='Close'
                              backgroundColor='transparent'
                              textColor='secondary'
                              textClassName='dark:text-secondary-dark'
                              classNames='mx-auto !py-2 w-[47px] h-9'
                              textSize='small'
                              textMarginX='0'
                              onClick={ () => {
                                 onCloseSuccessModal()
                              } }
                           />
                        </div>
                        : <>
                           <p className='text-major dark:text-major-dark text-xl text-center font-medium leading-tight'>
                              Thanks for your purchase!
                           </p>
                           <p className='text-secondary dark:text-secondary-dark text-center leading-tight mt-4'>
                              {
                                 isVideoDownoadPurchase ?
                                    <p>Your payment was successful. Please note that this content will be available for download for <span className='font-bold'>30 days</span> only.</p>
                                    :
                                    'Your payment was successful.'
                              }
                           </p>
                           {
                              transacationId && (
                                 <p className='text-secondary dark:text-secondary-dark text-center leading-tight mt-2 text-sm'>
                                    Transaction ID: { transacationId}
                                 </p>
                              )
                           }
                           {
                              'voice_unlock' === type && mediaData?.src && (
                                 <div className='flex flex-col mt-3 bg-[#F3F4F5] dark:bg-panel-dark p-3 rounded-full'>
                                    <Waveform
                                       type='mp3'
                                       duration={ mediaData?.duration || 0 }
                                       url={ mediaData?.src  }
                                       colorState={ {
                                          waveColor: window.site_dark_bg ? '#e0e0e01f' : '#6670851f',
                                          progressColor: window.site_dark_bg ? '#E0E0E0' : '#667085',
                                       } }
                                    />
                                 </div>
                              )
                           }
                           {
                              mediaUrl && type !== 'wallet' && (
                                 <a
                                    onClick={ () => clearErrorState() }
                                    href={ mediaUrl }
                                    className='flex mt-6'
                                 >
                                    {
                                       src && (
                                          <div
                                             className='rounded-lg overflow-hidden relative cursor-point media-small-card w-full aspect-video'
                                          >
                                             <img src={ src } alt='' className='h-full w-full object-center object-contain z-10' />
                                             {
                                                ('photoset' === type || 'photo_unlock' === type) && (
                                                   <div
                                                      className='absolute top-0 left-0 w-full h-full bg-cover bg-center z-0'
                                                      style={ {
                                                         backgroundImage: `url(${ src })`,
                                                         zIndex: -1,
                                                         filter: 'blur(24px)',
                                                      } }
                                                   />
                                                )
                                             }
                                             {
                                                time && (
                                                   <div
                                                      className='flex items-center justify-end w-full p-2 z-30 absolute top-0 right-0'
                                                      style={ {
                                                         background: 'linear-gradient(360deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%)',
                                                      } }
                                                   >
                                                      <div className='inline-flex rounded z-10'>
                                                         <div className='h-5 w-5 flex items-center justify-center mr-1'>
                                                            <Icon name={ icon } color='major-dark' size='base' />
                                                         </div>
                                                         <span className='text-major-dark text-sm'>
                                                            { time }
                                                         </span>
                                                      </div>
                                                   </div>
                                                )
                                             }
                                             {
                                                !isChat &&
                                                <div className='absolute w-full flex justify-end pr-2'>
                                                   <Button
                                                      iconName={ `star${ isFavoriteItem ? '' : '-outline' }` }
                                                      fontIconColor='major-dark'
                                                      fontIconSize='doubleLarge'
                                                      padding='0'
                                                      backgroundColor='transparent'
                                                      onClick={ (e) => {
                                                         e.preventDefault()
                                                         e.stopPropagation()
                                                         let contentType = videoType === 'livestream' ? 'recorded_stream' : type
                                                         if(contentType.includes('photo')) contentType = 'photoset'
                                                         if(contentType.includes('video')) contentType = 'video'
                                                         onChangeFavoriteItem(mediaData.id, contentType, () => {
                                                            setIsFavourieItem(!isFavoriteItem)
                                                         })
                                                      } }
                                                      classNames='!w-fit absolute -top-[30px] right-0 z-10 '
                                                      dataToolTipContent={ isFavoriteItem ? 'Remove from favorites' : 'Add to favorites' }
                                                   />
                                                </div>
                                             }
                                          </div>

                                       )
                                    }
                                 </a>
                              )
                           }
                           {
                              isShowButton ? (
                                 <div className='w-full mt-4 mb-10 h-10'>
                                    <Button
                                       iconPosition='left'
                                       text={ buttonText }
                                       textSize='base'
                                       classNames='h-full leading-tight'
                                       padding='none'
                                       borderRadius='large'
                                       primaryColor
                                       onClick={ () => {
                                          clearErrorState();
                                          goToMedia(mediaUrl)
                                       } }
                                       alignment='around'
                                    />
                                 </div>
                              ) : (
                                 <>
                                    {
                                       isVideoDownoadPurchase &&
                                       <div className='flex flex-col gap-3 items-center mt-8'>
                                          <Button
                                             iconPosition='left'
                                             iconName='download'
                                             text='Download'
                                             textSize='small'
                                             classNames='h-full leading-tight'
                                             padding='none py-2 px-3.5'
                                             borderRadius='large'
                                             primaryColor
                                             onClick={ (e) => {
                                                e.stopPropagation()
                                                onClickButton('download', e)
                                             } }
                                          />
                                          <Button
                                             text='Ok'
                                             textSize='small'
                                             classNames='h-full leading-tight'
                                             padding='none py-2 px-3.5'
                                             borderRadius='large'
                                             backgroundColor='transparent'
                                             onClick={ (e) => {
                                                e.stopPropagation()
                                                onClickButton('close', e)
                                             } }
                                             textColor='secondary'
                                             textClassName='text-secondary dark:text-secondary-dark'
                                          />
                                       </div>
                                    }
                                 </>
                              )
                           }
                        </>
                  ) : (
                     <>
                        <p
                           className='text-center text-2xl mb-3 dark:text-major-dark text-major'
                           style={ { lineHeight: '28px' } }
                        >
                           Tip sent!
                        </p>
                        <p
                           className='text-sm text-secondary dark:text-secondary-dark text-center'
                           style={ { lineHeight: '20px', maxWidth: '255px' } }
                        >
                           {
                              ('live_stream' === extraInfo?.tip_type && extraInfo?.tip_action) ? (
                                 <>
                                    Your tip for <span className='font-bold text-major dark:text-major-dark'>{ extraInfo?.tip_action.name }</span> has been sent to { ownername }.
                                 </>
                              ) : (
                                 `Your tip has been successfuly sent to ${ ownername }.`
                              )

                           }
                        </p>
                     </>
                  )
               }
            </div>
         </div>
         {
            ['chat_voice_message', 'tip', 'chat_photo_message', 'chat_text_message', 'multiple_attachment'].includes(type) && (
               <div className={ `flex w-full justify-center h-12 items-center cursor-pointer mb-2 ${ 'tip' === type ? 'mt-14' : '' }` }>
                  <div >
                     <Button
                        text={ type === 'tip' ? 'Close' : "Ok" }
                        textSize='base'
                        textColor='secondary dark:text-secondary-dark'
                        padding='none'
                        classNames='h-full w-auto px-3'
                        backgroundColor='panel dark:bg-panel-dark'
                        onClick={ (e) => onModalClose(e, 'tip' === type) }
                     />
                  </div>
               </div>
            )
         }
      </div>
   );
};


PurchaseMethodModal.propTypes = {
   onModalClose: PropTypes.func,
   onSend: PropTypes.func,
   goToWalletTopUp: PropTypes.func,
   goBack: PropTypes.func,
   selectedAmount: PropTypes.any,
   balance: PropTypes.number,
   ownername: PropTypes.string,
   ownerAvatar: PropTypes.string,
   isMobile: PropTypes.bool,
   isDisabled: PropTypes.bool,
   isSend: PropTypes.bool,
   isNotEnoughtBalance: PropTypes.bool,
   isGoBack: PropTypes.bool,
   onDownload: PropTypes.func,
   type: PropTypes.string,
   isOpenChoosePaymentModal: PropTypes.bool,
   onContinue: PropTypes.func,
   savedPaymentMethod: PropTypes.object,
   animate: PropTypes.string,
   height: PropTypes.number,
   isFetchingBalance: PropTypes.bool,
   mediaName: PropTypes.string,
   isCheckLimitFetching: PropTypes.bool,
   mediaData: PropTypes.object,
   goToMedia: PropTypes.func,
   locationPath: PropTypes.string,
   methods: PropTypes.object,
   oneClickInfo: PropTypes.object,
   paymentError: PropTypes.object,
   clearErrorState: PropTypes.func,
   onlyWalletPay: PropTypes.bool,
   paymentSend: PropTypes.func,
   contentData: PropTypes.object,
   chatPanel: PropTypes.object,
   videoType: PropTypes.string,
   extraInfo: PropTypes.object,
   purchaseData: PropTypes.object,
   onCloseSuccessModal: PropTypes.func,
   isFetchingModal: PropTypes.bool,
   siteInfo: PropTypes.object,
   onShare: PropTypes.func,
   pageType: PropTypes.string,
   onChangeFavoriteItem: PropTypes.func,
   isChat: PropTypes.bool,
   isDownloadPurchase: PropTypes.bool,
};

SendContent.propTypes = {
   onModalClose: PropTypes.func,
   contentType: PropTypes.string,
   ownername: PropTypes.string,
   mediaData: PropTypes.object,
   goToMedia: PropTypes.func,
   locationPath: PropTypes.string,
   videoType: PropTypes.string,
   clearErrorState: PropTypes.func,
   extraInfo: PropTypes.object,
   purchaseData: PropTypes.object,
   onCloseSuccessModal: PropTypes.func,
   siteInfo: PropTypes.object,
   onShare: PropTypes.func,
   onChangeFavoriteItem: PropTypes.func,
   isChat: PropTypes.bool,
   isDownloadPurchase: PropTypes.bool,
   onClickButton: PropTypes.func,
}

PurchaseMethodModal.defaultProps = {
   onModalClose: () => {},
   goBack: () => {},
   onDownload: () => {},
   selectedAmount: 10,
   isDisabled: false,
   type: 'tip',
   purchaseData: {},
   onCloseSuccessModal: () => {},
   onShare: () => {},
   onChangeFavoriteItem: () => {},
   isChat: false,
}
export default React.memo(PurchaseMethodModal);
